declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    fbq?: (...args: any[]) => void;
  }
}

// Helper to check if GA is loaded and consent is given
const isAnalyticsEnabled = (): boolean => {
  return typeof window.gtag === 'function';
};

// E-commerce Events

export const trackPurchase = (
  transactionId: string,
  value: number,
  items: Array<{
    item_id: string;
    item_name: string;
    item_category?: string;
    price: number;
    quantity: number;
    item_brand?: string;
  }>
) => {
  if (!isAnalyticsEnabled()) return;

  window.gtag!('event', 'purchase', {
    transaction_id: transactionId,
    value: value,
    currency: 'SEK',
    items: items,
  });
};

export const trackAddToCart = (
  itemId: string,
  itemName: string,
  price: number,
  quantity: number = 1,
  category?: string,
  artistName?: string
) => {
  if (!isAnalyticsEnabled()) return;

  window.gtag!('event', 'add_to_cart', {
    currency: 'SEK',
    value: price * quantity,
    items: [
      {
        item_id: itemId,
        item_name: itemName,
        item_category: category,
        item_brand: artistName,
        price: price,
        quantity: quantity,
      },
    ],
  });
};

export const trackViewItem = (
  itemId: string,
  itemName: string,
  price: number,
  category?: string,
  artistName?: string
) => {
  if (!isAnalyticsEnabled()) return;

  window.gtag!('event', 'view_item', {
    currency: 'SEK',
    value: price,
    items: [
      {
        item_id: itemId,
        item_name: itemName,
        item_category: category,
        item_brand: artistName,
        price: price,
      },
    ],
  });
};

export const trackViewArtist = (
  artistId: string,
  artistName: string,
  artworkCount?: number
) => {
  if (!isAnalyticsEnabled()) return;

  window.gtag!('event', 'view_artist', {
    artist_id: artistId,
    artist_name: artistName,
    artwork_count: artworkCount,
  });
};

// Engagement Events

export const trackArtworkUpload = (
  artworkId: string,
  artworkType: string,
  category: string,
  price: number
) => {
  if (!isAnalyticsEnabled()) return;

  window.gtag!('event', 'artwork_upload', {
    artwork_id: artworkId,
    artwork_type: artworkType,
    category: category,
    price: price,
  });
};

export const trackFollow = (artistId: string, action: 'follow' | 'unfollow') => {
  if (!isAnalyticsEnabled()) return;

  window.gtag!('event', action, {
    artist_id: artistId,
  });
};

export const trackSearch = (searchTerm: string, resultCount: number) => {
  if (!isAnalyticsEnabled()) return;

  window.gtag!('event', 'search', {
    search_term: searchTerm,
    result_count: resultCount,
  });
};

// Auction Events

export const trackPlaceBid = (
  artworkId: string,
  artworkTitle: string,
  bidAmount: number
) => {
  if (!isAnalyticsEnabled()) return;

  window.gtag!('event', 'place_bid', {
    artwork_id: artworkId,
    artwork_title: artworkTitle,
    bid_amount: bidAmount,
    currency: 'SEK',
  });
};

// Consent Management

export const updateConsent = (analyticsEnabled: boolean) => {
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: analyticsEnabled ? 'granted' : 'denied',
    });
  }
  
  // Meta Pixel consent
  if (typeof window.fbq === 'function') {
    window.fbq('consent', analyticsEnabled ? 'grant' : 'revoke');
  }
};
